import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AzureApiService } from "../../services/azure-api.service";
import {DtoCustomerFilter} from "./models/DtoCustomerFilter";
import {DtoCustomerSearch} from "./models/DtoCustomerSearch";

@Injectable()
export class CustomerSearchService {
    private apiUrl: string;

    constructor(private http: AzureApiService) {
        this.apiUrl = 'customer'
    }

    public searchCustomers = (filter: DtoCustomerFilter, pageIndex: number, pageSize: number): Observable<DtoCustomerSearch[]> => {
        return this.http.post<DtoCustomerSearch[]>(`${this.apiUrl}/filteredpaged/${pageIndex}/${pageSize}`, filter);
    };
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/customers/customer-search/customer-search.service.ts